import axios from '@/axios'

// console.log(axios)

export const getLocation = (data) => axios.post('/selfFiling/getAreaList', data)

export const getCourtList = (data) => axios.post('/selfFiling/getCourtList', data)

export const getCourtAddrList = (data) => axios.post('/selfFiling/getCourtAddrList', data)
// 法标数据接口
export const getDictByKind = (data) => axios.post('/selfFiling/getDictByKind', data)

export const getCauseOfActionList = (data) => axios.post('/selfFiling/getCauseOfActionList', data)
// 获取租户的业务页面信息
export const getTenantPage = (data) => axios.post('/selfFiling/getTenantPage', data)
// 获取案件材料列表
export const getMaterialList = (data) => axios.post('/selfFiling/getMaterialList', data)

// 获取省市辖区列表
export const getNationalAreaList = (data) => axios.post('/home/getAreasByParentsCode', data)

//  自助立案确认
export const selfFilingSubmit = (data) => axios.post('/selfFiling/selfFilingSubmit', data)

//  立案须知材料
export const gethtmlElement = (data) => axios.post('/home/htmlElement', data)

// 重新立案
export const getCrossDomainCaseInfo = (data) => axios.post('/filingSearch/getCrossDomainCaseInfo', data)

// 跨域案件材料补正
export const crossMaterialSupplement = (data) => axios.post('/selfFiling/crossMaterialSupplement', data)



// WEBPACK FOOTER //
// ./src/api/selfFiling.js